import {
  getFulfillmentEditorOrderShippedBody,
  getFulfillmentEditorOrderShippedSubject,
  getFulfillmentEditorReadyForPickupBody,
  getFulfillmentEditorReadyForPickupSubject,
  Locales,
} from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";

const chip = (variable: string, label: string) =>
  `<span data-custom-variable="{{${variable}}}" class="fr-deletable styled-tag-chip" contenteditable="false">${label}</span>`;

export const getDefaultReadyForPickupSubject = (locale: Locales): string =>
  getFulfillmentEditorReadyForPickupSubject(locale);

export const getDefaultOrderShippedSubject = (locale: Locales): string =>
  getFulfillmentEditorOrderShippedSubject(locale);

export const getDefaultReadyForPickupBody = (orgName: string, locale: Locales, t: Translate): string =>
  getFulfillmentEditorReadyForPickupBody({
    locale,
    orgName,
    firstName: chip("firstname", t("common", "firstName")),
    orderDetails: chip("Order details", t("dashboard", "liveFormEditor.fulfillmentEmail.variable.orderDetails")),
    pickupAddress: chip("Pickup address", t("dashboard", "liveFormEditor.fulfillmentEmail.variable.pickupAddress")),
    pickupInstructions: chip(
      "Pickup instructions",
      t("dashboard", "liveFormEditor.fulfillmentEmail.variable.pickupInstructions")
    ),
  });

export const getDefaultOrderShippedBody = (orgName: string, locale: Locales, t: Translate): string =>
  getFulfillmentEditorOrderShippedBody({
    locale,
    orgName,
    firstName: chip("firstname", t("common", "firstName")),
    orderDetails: chip("Order details", t("dashboard", "liveFormEditor.fulfillmentEmail.variable.orderDetails")),
  });
